import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import GS from "@ts/GlobalSetting";
import ViewportRoot, { getViewportName } from "@ts/sframe/ViewportRoot";

import { gsap } from "gsap";
import { Emitter } from "strict-event-emitter";



export default class ProductNav extends ComponentBase
{
  static instance: ProductNav;
  static to(hash: string)
  {
    if (this.instance) this.instance.to(hash);
  }

  isStuck: boolean = false;

  emiiter: Emitter<{triggered: [isCollapseAbleContent: boolean]}>;

  constructor(elem: ComponentElem)
  {
    super(elem);

    this.emiiter = new Emitter();

    ProductNav.instance = this;

    let $buttons = this.$root.find(".button");
    $buttons.on("click", (event: Event) =>
    {
      event.preventDefault();

      let elem: HTMLElement = event.target as HTMLElement,
        target = elem.getAttribute("href"),
        isCollapseAbleContent = elem.getAttribute("is-collapse-able-content") === "true";


      this.to(target, isCollapseAbleContent);
    });

    window.addEventListener("scroll", () =>
    {
      this._updateScrollTop();
    });

    this._updateScrollTop();
  }

  to(hash: string, isCollapseAbleContent: boolean = false)
  {
    // console.log("to " + hash);

    this.emiiter.emit("triggered", isCollapseAbleContent);    

    // console.log(isCollapseAbleContent);    

    // 等待被收闔內容展開後再處理
    setTimeout(()=>
    {
      let navHeight = GS.getNavHeight(),
        myNavHeight = this.isStuck ? 50 : 70,
        productNavStickyHeight = getViewportName() === "mobile"? 0: myNavHeight,
        offsetY = navHeight + productNavStickyHeight - 1;
  
      gsap.to(window, { duration: .5, scrollTo: { y: hash, offsetY: offsetY } });

    }, 100);
  }

  _updateScrollTop()
  {
    let navHeight = GS.getNavHeight();

    let bound = this.$root[0].getBoundingClientRect();

    this.isStuck = bound.top <= navHeight;
    this.$root.attr("stuck", this.isStuck ? "true" : "false");
  }
}